export default {
  group: [
    {
      sortable: false,
      text: "Transaction Id & Date",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "payment_id",
    },
    {
      sortable: false,
      text: "Group Name",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "group_detail",
    },
    {
      sortable: false,
      text: "Member Name",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "member_detail",
    },
    {
      sortable: false,
      text: "Amount",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "total_price",
    },
    {
      sortable: false,
      text: "Membership Status",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "membership_status",
    },
    {
      sortable: false,
      text: "Transaction Status",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "payment_status",
    },
  ],
  video: [
    {
      sortable: false,
      text: "Transaction Id & Date",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "payment_id",
    },
    {
      sortable: false,
      text: "Video/Playlist Name",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "video_playlist",
    },
    {
      sortable: false,
      text: "Subscriber Name",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "member_detail",
    },
    {
      sortable: false,
      text: "Amount",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "total_price",
    },
    {
      sortable: false,
      text: "Membership Status",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "membership_status",
    },
    {
      sortable: false,
      text: "Transaction Status",
      align: "center",
      class: ["tableHeader-text", "tableHeader-bg"],
      value: "payment_status",
    },
  ],
};
